import { create } from 'zustand';

type EventType =
  | 'idle'
  | 'reviewing'
  | 'Submitting'
  | 'submitted'
  | 'typing'
  | 'Selecting token'
  | 'Loading'
  | 'Insufficient balance'
  | 'Approve available'
  | 'Approving'
  | 'Something went wrong'
  | 'Payment successful'
  | 'Rejected the transaction'
  | 'Selecting Swap';

interface Store {
  event: EventType;
  trackEvent: (activity: Store['event']) => void;
}

// This is a simple store that tracks the current activity of the user that can be used to feed into
const useActivityTracker = create<Store>()((set) => ({
  event: 'idle',
  trackEvent: (activity) => set({ event: activity }),
}));

export default useActivityTracker;
